module.exports = __webpack_public_path__ + "294e9e0b9f5d6051f8537b93fb3f12bc.png";